// Served from public/ so the PWA asset generator writes its icon set alongside it.
const fieldbookLogo = "/logo-no-bg.png"

export function AppInstallPrompt() {
  return (
    <pwa-install
      icon={fieldbookLogo}
      // install-description only displayed on iOS
      install-description="See instructions to install by clicking the button below"
      name="Fieldbook"
      description="Ecological field data collection by Fieldwork Labs"
    ></pwa-install>
  )
}
